module.exports = __webpack_public_path__ + "img/dynamic-27.7e972519.png";